const pageUrl = encodeURIComponent(window.location.href);

function shareNews() {
	const shareBlock = document.querySelector('.share__list')
	const shareLinks = document.querySelectorAll('[data-share]')

	if (shareLinks.length > 0) {
		shareLinks.forEach(function(link) {
			link.addEventListener('click', function(event) {
				event.preventDefault();
				const shareType = this.getAttribute('data-share');

				switch (shareType) {
					case 'telegram':
						window.open(`https://t.me/share/url?url=${pageUrl}`, '_blank');
						break;
					case 'vk':
						window.open(`https://vk.com/share.php?url=${pageUrl}`, '_blank');
						break;
					case 'copy':
						let copyAlert = document.createElement('div')
						copyAlert.classList.add('copy-alert')
						navigator.clipboard.writeText(window.location.href).then(() => {
							copyAlert.innerText = `Ссылка скопирована в буфер обмена!`
							shareBlock.append(copyAlert)
							setTimeout(() => {
								copyAlert.remove()
							}, 2000)
						}, (err) => {
							copyAlert.innerText = `Ошибка при копировании ссылки.`
							shareBlock.append(copyAlert)
							setTimeout(() => {
								copyAlert.remove()
							}, 2000)
						});
						break;
					default:
						console.error('Неизвестный тип поделиться.');
				}
			});
		});
	}
}

shareNews();
